export default class Modal {
    constructor($modal) {
        this.$modal = $modal;
        this.$content = $modal.querySelector('[data-modal-content]');
        this.updateUrl = true;
        this.id = $modal.dataset.modal;
        this.$triggers = document.querySelectorAll(`[data-open-modal="${this.id}"]`);
        this.$closeTriggers = this.$modal.querySelectorAll('[data-close-modal]');

        if (this.$modal.dataset.updateUrl)  {
            this.updateUrl = this.$modal.dataset.updateUrl === "true";
        }

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.isActive = this.isActive.bind(this);
        this.documentClicked = this.documentClicked.bind(this);
        this.modalOpenedInDocument = this.modalOpenedInDocument.bind(this);
        this.modalOpenEventTriggered = this.modalOpenEventTriggered.bind(this);
        this.checkUrl = this.checkUrl.bind(this);

        this.$triggers.forEach( $trigger => $trigger.addEventListener('click', this.openModal));
        this.$closeTriggers.forEach( $trigger => $trigger.addEventListener('click', this.closeModal));

        // click outside
        document.addEventListener('click', this.documentClicked);
        // if another modal opens we close this one
        document.addEventListener('model-opened', this.modalOpenedInDocument);
        // a modal open event was triggered
        document.addEventListener('open-model', this.modalOpenEventTriggered);

        this.checkUrl();
    }

    checkUrl() {
        if(window.location.hash === '#' + this.id) {
            this.openModal();
        }
    }

    isActive() {
        return this.$modal.classList.contains('modal--visible');
    }

    openModal(e) {
        if(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
        }

        // notify body about opening a modal;
        var event = new CustomEvent("model-opened", {'detail': {
            id: this.id,
        }});

        document.dispatchEvent(event);

        if (this.$modal.querySelectorAll('#youtube-player[src*="youtube"]').length > 0 && player && typeof player.playVideo === "function") {
            player.playVideo();
        }

        document.querySelector('body').classList.add('no-scroll');

        this.$modal.classList.add('modal--visible');

        if (this.updateUrl) {
            // set the hash from the url
            window.location.hash = this.id;
        }
    }

    closeModal(e) {
        e.preventDefault();
        this.$modal.classList.remove('modal--visible');
        document.querySelector('body').classList.remove('no-scroll');

        if (this.$modal.querySelectorAll('#youtube-player[src*="youtube"]').length > 0 && player && typeof player.playVideo === "function") {
            player.stopVideo();
        }

        if (this.$modal.querySelector('video')) {
            this.$modal.querySelector('video').pause();
        }

        if (this.updateUrl) {
            history.pushState({}, '', placeholders.currentUri);
        }
    }

    modalOpenEventTriggered(e) {
        if(e.detail.id === this.id) {
            this.openModal(e);
        }
    }

    modalOpenedInDocument(e) {
        if(e.detail.id !== this.id && this.isActive()) {
            this.closeModal(e);
        }
    }

    documentClicked(e) {
        // prevent scripts close the modal password
        if(e.target.type === 'password') {
            return false;
        }

        // if we click on a trigger we open the model and stop here
        if(e.target.closest(`[data-open-modal="${this.id}"]`) !== null) {
            this.openModal(e);
            return;
        }

        const isClickInside = this.$content.contains(e.target);
        let isTrigger = false;

        for(const $trigger of this.$triggers.values()) {
            if($trigger == e.target || $trigger.contains(e.target)){
                isTrigger = true;
            }
        }

        if (!isClickInside && !isTrigger && this.$modal.classList.contains('modal--overlay') && this.isActive()) {
            this.closeModal(e);
        }

    }
}